import { PageOutdatedStatus } from '@tinct/core-api-models';

/**
 * Display config for the page "outdated" indicator. `none` is intentionally
 * omitted — a page in sync shows no badge at all. Both out-of-sync states read
 * as one "Outdated": a page needing regeneration is regenerated as soon as the
 * campaign is seen (see useAutoRegenerateOutdatedPages), after which it only
 * awaits republication, so the user has a single thing to do. The model keeps
 * the two apart so an "Outdated" badge that never clears can be traced to the
 * step that did not run.
 */
export const PAGE_OUTDATED_STATUS_CONFIG: Record<
  Exclude<PageOutdatedStatus, 'none'>,
  { label: string }
> = {
  needs_regeneration: { label: 'Outdated' },
  needs_republication: { label: 'Outdated' },
};
